module.exports = __webpack_public_path__ + "media/images/team/SMarina-1c714083f51066bfa41343fa52a6fb90.jpg";